import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
export class CatalogueCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Catalogue"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-2"></div>
                <div className="ui-g-8">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Name *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.name}
                        onChange={e =>
                          this.props.updateValue("name", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Description *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.description}
                        onChange={e =>
                          this.props.updateValue("description", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Categorys</label>
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <pr.DataTable
                      ref={el => {
                        this.dt = el;
                      }}
                      reorderableColumns={false}
                      selectionMode="single"
                      onSelectionChange={e => {}}
                      value={this.props.editedObject.categoryList}
                      dataKey="id"
                      emptyMessage="No Properties"
                      rows={100}
                      autoLayout={true}
                      style={{ borderColor: "transparent" }}
                    >
                      <pr.Column
                        field="name"
                        header="Name"
                        editor={this.categoryNameEditor}
                        sortable={true}
                        style={{ overflow: "auto" }}
                      ></pr.Column>

                      <pr.Column
                        field="description"
                        header="Description"
                        editor={this.categoryDescriptionEditor}
                        sortable={true}
                        style={{ overflow: "auto" }}
                      ></pr.Column>
                      <pr.Column
                        key="add"
                        body={this.getCategoryRemoveTemplate}
                        style={{ textAlign: "center", width: "8em" }}
                        header={
                          <div className="ui-g">
                            <div className="ui-g-12">
                              <pr.Button
                                className="secondary-btn"
                                icon="pi pi-plus"
                                onClick={e => {
                                  this.props.addCategory();
                                }}
                                style={{}}
                              />
                            </div>
                          </div>
                        }
                      />
                    </pr.DataTable>
                    {/* <pr.TreeTable
                      value={this.convertCategorysToTreeNode(
                        this.props.editedObject.categoryList
                      )}
                      header={
                        <div className="ui-g">
                          <div className="ui-g-12">
                            <pr.Button
                              className="secondary-btn"
                              icon="pi pi-plus"
                              label={"Add Category"}
                              onClick={() => {}}
                              style={{ float: "right" }}
                            />
                          </div>
                        </div>
                      }
                    >
                     
                    </pr.TreeTable> */}
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }

  getCategoryColumns = () => {
    console.log(this.props);
    var allColumns = [];
    // allColumns.push(
    //   <pr.Column
    //     key="expander"
    //     expander={true}
    //     style={{ width: "5em", float: "middle" }}
    //   />
    // );
    if (format.isNotNull(this.props.categoryColumns)) {
      let columns = this.props.categoryColumns.map((col, i) => {
        return (
          <pr.Column
            key={col.field}
            field={col.field}
            header={col.header}
            sortable={col.sortable}
            filter={col.filter}
            filterMatchMode={col.filterMatchMode}
            style={col.style}
          />
        );
      });

      columns.forEach(e => {
        allColumns.push(e);
      });
    }
    return allColumns;
  };

  getCategoryRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.props.removeCategory(rowData);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };

  convertCategorysToTreeNode = categoryList => {
    var nodes = [];
    if (format.isNotNull(categoryList)) {
      categoryList.forEach(element => {
        var nodeObject = {};
        nodeObject.key = element.id;
        nodeObject.data = element;
        nodes.push(nodeObject);
      });
    }
    return nodes;
  };
  categoryNameEditor = props => {
    return this.categoryNameInputTextEditor(props, "name");
  };
  categoryNameInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onCategoryEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
  onCategoryEditorValueChange = (row, field, value) => {
    let updatedList = this.props.editedObject.categoryList;
    updatedList[row][field] = value;

    this.props.updateValue("categoryList", updatedList);
  };
  categoryDescriptionEditor = props => {
    return this.categoryDescriptionInputTextEditor(props, "description");
  };
  categoryDescriptionInputTextEditor = (props, field) => {
    return (
      <pr.InputText
        type="text"
        value={props.rowData[field] || ""}
        onChange={e =>
          this.onCategoryEditorValueChange(
            props.rowIndex,
            props.field,
            e.target.value
          )
        }
      />
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/UI/CatalogueCard.js